import { render } from "./WordEndingsVerbs.vue?vue&type=template&id=c36e7cb4&scoped=true"
import script from "./WordEndingsVerbs.vue?vue&type=script&lang=js"
export * from "./WordEndingsVerbs.vue?vue&type=script&lang=js"

import "./WordEndingsVerbs.vue?vue&type=style&index=0&id=c36e7cb4&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c36e7cb4"]])

export default __exports__